import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=563bc110&scoped=true&"
import script from "./DocumentDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bc110",
  null
  
)

export default component.exports